import gql from 'graphql-tag';

import * as fragments from '../fragments';

export const FOLLOW_TOPIC = gql`
  mutation FollowTopic($topicId: ID!, $followedBy: ID!) {
    followTopic(topicId: $topicId, followedBy: $followedBy) {
      name
      followedBy {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;

export const BOOKMARK_TOPIC = gql`
  mutation BookMarkTopic($topicId: ID!, $bookmarkedBy: ID!) {
    bookmarkTopic(topicId: $topicId, bookmarkedBy: $bookmarkedBy) {
      name
      bookmarkedBy {
        ...identificationFields
      }
    }
  }

  ${fragments.IDENTIFICATION_FRAGMENT}
`;
